import CategoryManager from '../features/catalog/CategoryManager';
import ItemGroupManager from '../features/catalog/ItemGroupManager';

export default function CategoriesPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Menü Kategorileri</h1>
          <p>Ürünleri seçili kategorilere ayırın ve görünürlüklerini kontrol edin.</p>
        </div>
      </header>
      <section className="page-section">
        <div className="page-section-header">
          <div>
            <h2>Item groups</h2>
            <p>Üst seviye katalog başlıklarını yönetin (örn. Pizzalar, İçecekler).</p>
          </div>
        </div>
        <ItemGroupManager />
      </section>

      <section className="page-section">
        <div className="page-section-header">
          <div>
            <h2>Kategoriler</h2>
            <p>Gruplar altında yer alan alt kategorileri ve hiyerarşiyi yönetin.</p>
          </div>
        </div>
        <CategoryManager />
      </section>
    </div>
  );
}
